<a pButton
   *browserOnly
   [routerLink]="route()"
   [severity]="severity()"
   [class.w-full]="wide()"
   [class.max-w-60]="wide()"
   [queryParams]="routeQueryParams()"
   [size]="size()"
   [class.font-semibold]="bolder()"
>
  @let state = signupState();
  @if (state === 'not-signed-up') {
    {{ signupText() }}
  } @else {
    {{ stateMapping[state] }}
  }
</a>
